/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Bar Graph Icon component.
 */
export const NoIgnitionIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  return (
    <ThemeIconProvider name='NoIgnitionIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='-5 -5 27 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M22.0001 22.9V18.9L17.2494 14.2066L14.556 16.9H15.0001V19.9H18.0001V22.9H22.0001Z' fill='#828282'/>
        <path fillRule='evenodd' clipRule='evenodd' d='M9.67738 14.7075L13.7101 10.6749C13.9034 10.18 14.0001 9.58998 14.0001 9C14.0001 5.7 11.3001 3 8.00012 3C4.70012 3 2.00012 5.7 2.00012 9C2.00012 12.3 4.70012 15 8.00012 15C8.59253 15 9.08744 14.9025 9.67738 14.7075ZM5.00012 7.89999C5.00012 6.79999 5.90012 5.89999 7.00012 5.89999C8.10012 5.89999 9.00012 6.79999 9.00012 7.89999C9.00012 8.99999 8.10012 9.89999 7.00012 9.89999C5.90012 9.89999 5.00012 8.99999 5.00012 7.89999Z' fill='#828282'/>
        <rect x='23.3169' y='2.00721' width='3.5' height='30.5' transform='rotate(45 23.3169 2.00721)' fill='#828282' stroke='#F2F2F2' strokeWidth='1.5'/>
      </svg>
    )} />
  );
};
